import Axios from "./index";
import { parseFilters } from "./helper";

export const indexAlbums = params => {
  return Axios.get(`/user/albums`, { params: parseFilters(params) });
};

export const indexAlbum = (album_id, params = {}) => {
  return Axios.get(`/user/albums/${album_id}/album_media`, {
    params,
  });
};

export const updateAlbum = params => {
  return Axios.put(`/user/albums/${params.album.id}`, params);
};

export const showAlbum = album_id => {
  return Axios.get(`/user/albums/${album_id}`);
};
export const createAlbum = albumParams => {
  return Axios.post(`/user/albums`, albumParams);
};

export const indexAlbumMedia = (album_id, params = {}) => {
  return Axios.get(`/user/albums/${album_id}/album_media`, {
    params,
  });
};

export const deleteAlbum = album_id => {
  return Axios.delete(`/user/albums/${album_id}`);
};

export const removeMediumFromAlbum = (album_id, params) => {
  return Axios.delete(`/user/albums/${album_id}/album_media`, { data: params });
};

export const distributeAlbum = (album_id, params) => {
  return Axios.post(`/user/albums/${album_id}/distribute`, {type: params});
};
